<style scoped>
.directory{
    width: 210px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    color: #1797a7;
    padding: 40px 15px;
}
.directory_div{
    cursor: pointer;
    display: flex;
    align-items: center;
}
.directory_div span{
    margin-left: 10px;
    color: #1797a7;
    /* font-weight: 600; */
}
.el-icon-search:before{
    font-size: 0.8rem;
}
.el-icon-close:before{
    font-size: 1rem;
}
.dy_sty{
    color: #22978d !important;
}
@media screen and (min-width:2200px){
    .dy_sty{
        font-size: 0.65rem !important;
        color: #22978d;
    }
}

  
</style>
<style>
@media screen and (min-width:2200px){
    #cjwt_01 .el-collapse-item__content{
        font-size: 0.65rem !important;
        line-height: 1rem !important;
    }
    #cjwt_01 .el-collapse-item__header{
        font-size: 0.65rem !important;
    }
    #cjwt_01 .el-dialog__body{
        font-size: 0.65rem !important;
    }
}
</style>

<template>
    <div class="directory" id="cjwt_01" style="font-size: 0.75rem;background: #f0f7f0;">
        <div class="directory_div"  @click="additional(1)">
            <!-- <img src="../../image/icon/icon1.png" style="width:0.8rem;">
            <span>{{$t('login.lxwm')}}</span> -->
            <img src="../../image/icon/icon2.png" style="width:0.8rem;">
            <span class="dy_sty">{{$t('login.cjwt')}}</span>
        </div>
        <!-- @click="additional(2)" -->
        <!-- <div class="directory_div" style="margin-top: 1.1rem;" >
          
            <img src="../../image/icon/icon7.png" style="width:0.8rem;">
            <span class="dy_sty">{{$t('login.lxwm')}}</span>
        </div> -->
        <!-- <div class="directory_div" style="margin-top: 20px;" @click="additional(3)">
            <img src="../../image/icon/icon3.png" style="width:15px;">
            <span>{{$t('login.xgtk')}}</span>
        </div> -->
        <!-- <div class="directory_div" style="margin-top: 1.1rem;" @click="additional(4)">
            <img src="../../image/icon/icon4.png" style="width:0.8rem;">
            <span>{{$t('login.jszy')}}</span>
        </div> -->
        <div class="directory_div" style="margin-top: 1.1rem;display: flex;align-items: center;" @click="additional(5)">
            <img src="../../image/icon/icon5.png" style="width:0.8rem;height: 0.8rem;">
            <span class="dy_sty">{{$t('login.khjx')}}</span>
        </div>
        <!-- <div class="directory_div" style="margin-top: 1.1rem;display: flex;align-items: center;" @click="additional(6)">
            <img src="../../image/icon/icon6.png" style="width:0.8rem;height: 0.8rem;">
            <span>{{$t('login.xgzl')}}</span>
        </div> -->
        <div class="bullet">
            <el-dialog
            :showClose="false"
            :visible.sync="dialogVisible"
            width="50rem"
            :before-close="handleClose">
                <div class='mark-file' >
                    <div style="display:flex;align-items: center;width: 96%;position: absolute;top: 25px;">
                        <span style="flex-shrink: 0;" v-if="ifEng=='eng'">Search FAQs：</span>
                        <span style="flex-shrink: 0;" v-else>搜索常見問題：</span>
                        <el-input v-model="searchstr" />
                        <i style="margin-left:10px" class="el-icon-search" @click='getdate(0)'></i>
                        <i style="margin-left:10px" class="el-icon-close" @click='tc_close'></i>
                    </div>
                    <div style="margin-top:15px">
                        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane v-for=" (item,index) in islist " :key="index" :label="item" :name="item">
                                -->
                                <div style="height: 550px;overflow-y: auto;padding: 0 10px;">
                                    <el-collapse v-model="activeNames" @change="handleChange"  accordion>
                                        <el-collapse-item v-for=" (item1,index1) in islist_cen"  :key="index1"   :name="index1" :class="{'openSty' : zkFlag == index1  }">
                                            <div slot='title' style="word-break: break-word;white-space: pre-wrap;">{{item1.question}}</div>
                                            <div style="word-break: break-word;white-space: pre-wrap;" v-html="item1.answer"></div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                                <!-- 
                            </el-tab-pane>
                        </el-tabs> -->
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="isClickPlayer" :modal="false" width="50%" top="15vh">
                <!-- <div>
                    <video-player  class="video-player vjs-custom-skin" 
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div> -->
                <div style="height: 21rem;">
                    <video controls="" autoplay="" name="media" width="100%" height="100%" style="background:#000"  muted='true'>
                        <source :src="video_url" type="video/mp4">
                    </video>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import https from "@/plugins/http.js";
    export default {
       
        data(){
            return{
                video_url: 'https://hk.iqmis.com/videos/accountapp/account-eng-mobileapp.mp4',
                ifEng: this.$i18n.locale,
                isClickPlayer:false,
                dialogVisible: false,
                searchstr:'',
                activeName: '',
                list: [],
                islist: [],
                islist_cen: [],
                activeNames: [],
                zkFlag:null,
                // 视频播放
                playerOptions : {
                    playbackRates : [ 0.5, 1.0, 1.5, 2.0 ], //可选择的播放速度
                    autoplay : false, //如果true,浏览器准备好时开始回放。
                    muted : false, // 默认情况下将会消除任何音频。
                    loop : false, // 视频一结束就重新开始。
                    preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language : 'zh-CN',
                    aspectRatio : '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid : true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources : [ {
                        type : "video/mp4",
                        src : require('../../assets/QMIS-v-2016.mp4')//url地址
                    } ],
                    poster : "", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage : '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar : {
                        timeDivider : true,//当前时间和持续时间的分隔符
                        durationDisplay : true,//显示持续时间
                        remainingTimeDisplay : false,//是否显示剩余时间功能
                        fullscreenToggle : true  //全屏按钮
                    }
                }
            }
        },
        created(){
            console.log(this.keyIndex)
        },
        // watch: {
		// 	islist_cen: {
		// 		handler (newName, oldName) {
		// 			console.log('oldName',oldName)
		// 			console.log('newName',newName)
        //             this.islist_cen = newName
        //             console.log(this.islist_cen);
		// 		},
		// 		immediate: true
		// 	}
		// },
        mounted() {
            // this.getdate()
            this.video_url = this.ifEng == "eng"?'https://hk.iqmis.com/videos/accountapp/account-eng-mobileapp.mp4':'https://hk.iqmis.com/videos/accountapp/account-chi-mobileapp.mp4';
        },
        methods:{
            additional(val){
                if (val == 1) {
                    // window.open("http://localhost:8080/webkh/beCareful?lan="+this.ifEng);
                    // window.open("http://202.130.113.149/webkh/beCareful?lan="+this.ifEng);
                    this.dialogVisible = true;
                    this.activeName = this.$i18n.locale == 'big5'? '注意事項':'FAQs';
                    this.getdate(0);
                }
                if (val == 2) {
                    // window.open("https://www.qmisgroup.com/FAQs");
                    this.dialogVisible = true;
                    this.activeName = this.$i18n.locale == 'big5'? '常見問題':'FAQs';
                    this.getdate(1);
                }
                if (val == 3) {
                    // window.open("https://www.qmisgroup.com/privacypolicy");
                   
                }
                if (val == 4) {
                    
                    // window.open("https://www.qmisgroup.com/contactus");
                    this.dialogVisible = true;
                    this.activeName = this.$i18n.locale == 'big5'? '技術支援':'FAQs';
                    this.getdate(2);
                   
                }
                if (val == 5) {
                    // window.open("");
                    this.playerOptions.sources[0].src = 'https://hk.iqmis.com/videos/accountapp/account-eng-mobileapp-test2.mp4'
                    if(localStorage.getItem('lang') == 'big5'){
                        this.playerOptions.sources[0].src = 'https://hk.iqmis.com/videos/accountapp/account-chi-mobileapp-test.mp4'
                    }
                    this.isClickPlayer = !this.isClickPlayer
                }
                if (val == 6) {
                    this.dialogVisible = true;
                    // window.open("https://www.qmisgroup.com/service-fee&charge");
                    this.activeName = this.$i18n.locale == 'big5'? '相關資料':'FAQs';
                    this.getdate(4);
                }
            },
            handleClose(done) {
                done();
               
            },
            getdate(val) {

                // this.$ajax({
                // method: 'post',
                // url: this.$api.GroupFAQ,
                // data:{
                //     lan:this.ifEng,
                //     searchstr:this.searchstr,
                // }
                // }).then(res => {
                // this.list = res.data.FQAList
                // this.islist = []
                // this.list.map(val => {
                //     console.log(val)
                //     if(val.title === this.atitem.title){
                //     this.islist.push(true)
                //     }else{
                //     this.islist.push(false)
                //     }
                // })
                // })
                var url;
                if(location.protocol == 'https:') {
                    // url = 'https://hk.qmisit.com:2346/groupweb/getKHFAQ'
                    url = 'https://www.qmisgroup.com:2347/groupweb/getKHFAQ'
                }else{
                    url = 'http://202.130.113.149:2347/groupweb/getKHFAQ'
                    // url = 'http://202.130.113.149:2347/groupweb/getKHFAQ'
                }
                // url = 'https://hk.qmisit.com:3785/talk/getKHFAQ'
                https.fetchLoginPost(url, {
                    lan:this.ifEng,
                    searchstr:this.searchstr,
                }).then((data) => {
                    if (Object.is(data.qmiscode, 1000)) {
                        // debugger
                        this.list = data.FQAList;
                        console.log();
                        // this.islist = [];
                        this.islist_cen = this.list[val].sub;
                        // console.log(this.islist_cen);
                        // this.list.map(val => {
                        //    console.log(val.title);
                        //    this.islist.push(val.title)
                        // })
                    } else {
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch((err) => {
                    console.log(err);
                });

                
            },
            handleClick(tab, event) {
                console.log(tab._props.label);
                var atitem = tab._props.label;
                this.islist_cen = [];
                this.list.map(val => {
                    console.log(val)
                    if(val.title === atitem){
                        this.islist_cen = val.sub;
                    }
                })
                console.log(this.islist_cen);

            },
            handleChange(val) {
                console.log(val);
                this.zkFlag = val
            },
            tc_close(){
                this.dialogVisible = false;
            }

        }
    }
</script>

<style>
.directory .is-active .el-collapse-item__header{
    background-color: #3d7077 !important;
}
.directory .is-active .el-collapse-item__header div{
    color: #ffffff ;
}
.directory .is-active  .el-icon-arrow-right:before{
    color: #ffffff ;
}
 .bullet .el-dialog{
    border: 10px solid #3d7077;
    border-left: 0;
    border-right: 0;
}
 .bullet .el-dialog__headerbtn{
    top:30px;
}
.bullet .el-collapse-item{
    box-shadow: 0 0 15px #cbc9c9;
}
 .bullet .el-dialog__header{
    padding: 0.9rem;
    background: #f0f7f0;
}
 .bullet .el-tabs__item.is-active{
    color: #09666e;
}
 .bullet .el-tabs__item:hover{
    color: #09666e;
}
.bullet  .el-tabs__active-bar {
  background: #09666e;;
}
.bullet .el-tabs__nav-wrap::after {
    position: static !important;
}
.bullet .el-collapse{
    border: 0;
}
.bullet .el-dialog__body{
    font-size: 0.75rem;
    background: #f0f7f0;
}
.bullet .el-tabs__item{
    font-size: 0.75rem;
}
.directory .el-collapse-item__header{
    border: 0;
    background-color: #f4f4f4 ;
    margin-top: 20px !important;
    padding: 10px !important;
    font-size: 0.75rem;
    line-height: 20px;
}
.directory .el-collapse-item__wrap{
    border: 1px solid #EBEEF5 !important;
    border-top: 0  !important;
    padding: 15px 10px !important;
}
.el-collapse-item__content{
    padding-bottom:0;
    font-size: 15px;
}
</style>